import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscriber, Observable } from 'rxjs';

let  name = localStorage.getItem('articleSearch') || null;

@Injectable({
    providedIn: 'root'
})

export class SearchService {
    public nameToFind: BehaviorSubject<string> = new BehaviorSubject('');


    setNameToFind(nameSearch: string) {
        this.nameToFind.next(nameSearch);
    }

    getNameToFind(): Observable<string> {
        return this.nameToFind.asObservable();
    }

    getProductoABuscar() {
        const itemsStream = new Observable(observer => {
            observer.next(localStorage.getItem('articleSearch'));
            observer.complete();
        });
        return <Observable<string>>itemsStream;
    }

    vaciarProductoABuscar() {
        localStorage.removeItem('articleSearch');
        localStorage.removeItem('articleFilters');
        this.setNameToFind(null);
    }

    buscarProducto(producto) {
        localStorage.setItem('articleSearch', producto );
    }
}
